import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

type UserType = {
  userId?: string;
  email?: string;
  fullName?: string;
};

const initialState: UserType | null = null;

export const userStateSlice = createSlice({
  name: 'userStateSlice',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state = { ...action.payload };
      return state;
    },
    resetUserData: () => {
      return initialState;
    }
  }
});

export const { setUserData, resetUserData } = userStateSlice.actions;
export const getUserData = (state: RootState) => state.userStateSlice;
